document.addEventListener('DOMContentLoaded', () => {
    if ($(window).width() > 1101) {
      $(window).scroll(function () {
        if ($(window).scrollTop() + ($(window).height() * 2) / 3 > $('.aph320-imagewithtext').offset().top) {
          $('.aph320-imagewithtext').addClass('animate-text');
        } else {
          $('.aph320-imagewithtext').removeClass('animate-text');
        }
      });
    }
  });